module.exports = __webpack_public_path__ + "img/number_bg_02.122586d5.png";